// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidContractLineItemsPage_CanCreatePandaDocFragmentDoc } from '../../routes/developments/procurement/DevelopmentContractLineItemsPage.generated';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidContractRevisionUnitPricingQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
  skipPotentialUsages: Types.Scalars['Boolean']['input'];
}>;


export type BidContractRevisionUnitPricingQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, bidRequest?: { __typename?: 'BidPackageRequest', id: string } | null | undefined }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string } | null | undefined, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, ofBi: boolean, isTaxExempt: boolean, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', code: string, id: string, name: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string } } | null | undefined, potentialUsages?: Array<
        | { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'ProjectCustomItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ChangeEvent', id: string, displayName: string } }
        | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } }
        | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } }
      > }> } };

export type SaveBidContractUnitPricingMutationVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
  lineItems: Array<Types.SaveBidContractLineItemInput> | Types.SaveBidContractLineItemInput;
}>;


export type SaveBidContractUnitPricingMutation = { __typename?: 'Mutation', saveBidContractLineItems: { __typename?: 'SaveBidContractLineItemsResult', bidContractRevision: { __typename?: 'BidContractRevision', id: string, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type BidContractUnitPricingPage_BidContractLineItemFragment = { __typename?: 'BidContractLineItem', id: string, ofBi: boolean, isTaxExempt: boolean, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', code: string, id: string, name: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string } } | null | undefined, potentialUsages?: Array<
    | { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ItemTemplate', id: string, displayName: string } }
    | { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ItemTemplate', id: string, displayName: string } }
    | { __typename?: 'ProjectCustomItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ChangeEvent', id: string, displayName: string } }
    | { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } }
    | { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } }
  > };

export type BidContractUnitPricingPage_PotentialUsages_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ItemTemplate', id: string, displayName: string } };

export type BidContractUnitPricingPage_PotentialUsages_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ItemTemplate', id: string, displayName: string } };

export type BidContractUnitPricingPage_PotentialUsages_ProjectCustomItem_Fragment = { __typename?: 'ProjectCustomItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ChangeEvent', id: string, displayName: string } };

export type BidContractUnitPricingPage_PotentialUsages_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } };

export type BidContractUnitPricingPage_PotentialUsages_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, quantity?: number | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, first: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string } };

export type BidContractUnitPricingPage_PotentialUsagesFragment =
  | BidContractUnitPricingPage_PotentialUsages_ItemTemplateItemVersion_Fragment
  | BidContractUnitPricingPage_PotentialUsages_ItemTemplateItem_Fragment
  | BidContractUnitPricingPage_PotentialUsages_ProjectCustomItem_Fragment
  | BidContractUnitPricingPage_PotentialUsages_TakeoffLineItem_Fragment
  | BidContractUnitPricingPage_PotentialUsages_TakeoffLineItemVersion_Fragment
;

export const BidContractUnitPricingPage_PotentialUsagesFragmentDoc = gql`
    fragment BidContractUnitPricingPage_PotentialUsages on BaseItemLike {
  id
  development {
    ...Named
  }
  first {
    id
    displayName
  }
  displayName
  quantity
}
    ${NamedFragmentDoc}`;
export const BidContractUnitPricingPage_BidContractLineItemFragmentDoc = gql`
    fragment BidContractUnitPricingPage_BidContractLineItem on BidContractLineItem {
  id
  ofBi
  isTaxExempt
  bidItem {
    ...Named
    parentMaterialVariant {
      id
      displayName
    }
    parentTask {
      ...Named
    }
    costType {
      code
    }
    code
    unitOfMeasure {
      id
      shortName
    }
    costType {
      code
      name
    }
  }
  totalCostInCents
  potentialUsages @skip(if: $skipPotentialUsages) {
    ...BidContractUnitPricingPage_PotentialUsages
  }
}
    ${NamedFragmentDoc}
${BidContractUnitPricingPage_PotentialUsagesFragmentDoc}`;
export const BidContractRevisionUnitPricingDocument = gql`
    query BidContractRevisionUnitPricing($bidContractRevisionId: ID!, $skipPotentialUsages: Boolean!) {
  bidContractRevision(id: $bidContractRevisionId) {
    id
    bidContract {
      id
      bidRequest {
        id
      }
    }
    canEdit {
      allowed
      disabledReasons {
        message
      }
    }
    bidPackageVersion {
      id
    }
    lineItems {
      ...BidContractUnitPricingPage_BidContractLineItem
    }
  }
}
    ${BidContractUnitPricingPage_BidContractLineItemFragmentDoc}`;

/**
 * __useBidContractRevisionUnitPricingQuery__
 *
 * To run a query within a React component, call `useBidContractRevisionUnitPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractRevisionUnitPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractRevisionUnitPricingQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *      skipPotentialUsages: // value for 'skipPotentialUsages'
 *   },
 * });
 */
export function useBidContractRevisionUnitPricingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables> & ({ variables: BidContractRevisionUnitPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>(BidContractRevisionUnitPricingDocument, options);
      }
export function useBidContractRevisionUnitPricingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>(BidContractRevisionUnitPricingDocument, options);
        }
// @ts-ignore
export function useBidContractRevisionUnitPricingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>;
export function useBidContractRevisionUnitPricingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractRevisionUnitPricingQuery | undefined, BidContractRevisionUnitPricingQueryVariables>;
export function useBidContractRevisionUnitPricingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>(BidContractRevisionUnitPricingDocument, options);
        }
export type BidContractRevisionUnitPricingQueryHookResult = ReturnType<typeof useBidContractRevisionUnitPricingQuery>;
export type BidContractRevisionUnitPricingLazyQueryHookResult = ReturnType<typeof useBidContractRevisionUnitPricingLazyQuery>;
export type BidContractRevisionUnitPricingSuspenseQueryHookResult = ReturnType<typeof useBidContractRevisionUnitPricingSuspenseQuery>;
export type BidContractRevisionUnitPricingQueryResult = ApolloReactCommon.QueryResult<BidContractRevisionUnitPricingQuery, BidContractRevisionUnitPricingQueryVariables>;
export const SaveBidContractUnitPricingDocument = gql`
    mutation SaveBidContractUnitPricing($bidContractRevisionId: ID!, $lineItems: [SaveBidContractLineItemInput!]!) {
  saveBidContractLineItems(
    bidContractRevisionId: $bidContractRevisionId
    lineItems: $lineItems
  ) {
    bidContractRevision {
      id
      ...BidContractLineItemsPage_CanCreatePandaDoc
    }
  }
}
    ${BidContractLineItemsPage_CanCreatePandaDocFragmentDoc}`;

/**
 * __useSaveBidContractUnitPricingMutation__
 *
 * To run a mutation, you first call `useSaveBidContractUnitPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidContractUnitPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidContractUnitPricingMutation, { data, loading, error }] = useSaveBidContractUnitPricingMutation({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useSaveBidContractUnitPricingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidContractUnitPricingMutation, SaveBidContractUnitPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidContractUnitPricingMutation, SaveBidContractUnitPricingMutationVariables>(SaveBidContractUnitPricingDocument, options);
      }
export type SaveBidContractUnitPricingMutationHookResult = ReturnType<typeof useSaveBidContractUnitPricingMutation>;
export type SaveBidContractUnitPricingMutationResult = ApolloReactCommon.MutationResult<SaveBidContractUnitPricingMutation>;